import { useEffect } from "react";
import { trackPageViewV2 } from "../../../../services/analytics-adapter";
import HealthKitDebug from "../../components/HealthKitDebug";

export default function HealthKitDebugPage() {
  useEffect(() => {
    trackPageViewV2({
      pageName: "More:Health SDK Debug",
      pageSubSection1: "More",
      pageSubSection2: "More:Health SDK Debug",
      pageCategory: "More",
    });
  }, []);
  return <HealthKitDebug />;
}
